import _default, { shouldForwardProp as shouldForwardProp_1 } from "../../system/createStyled.js";
import defaultTheme from "./defaultTheme.js";
import THEME_ID from "./identifier.js";
const rootShouldForwardProp = (prop) => shouldForwardProp_1(prop) && prop !== "classes", styled = _default({
  themeId: THEME_ID,
  defaultTheme,
  rootShouldForwardProp
});
export {
  styled as default,
  rootShouldForwardProp
};
//# sourceMappingURL=styled.js.map
